<script setup lang="ts">
// Casca da área do cliente: somente consulta (F19). Sem navegação técnica e
// nenhum link administrativo. Tokens visuais equivalentes aos do Landwatch,
// sem Tailwind nem dependência dele.
</script>

<template>
  <div class="client-shell">
    <RouterView />
  </div>
</template>

<style>
.client-shell {
  --background: hsl(210 20% 98%);
  --foreground: hsl(222 47% 11%);
  --primary: hsl(142 72% 35%);
  /* Verde principal escurecido para fundo com texto branco (contraste AA). */
  --primary-strong: hsl(142 72% 27%);
  --secondary: hsl(210 20% 94%);
  --muted-foreground: hsl(215 16% 45%);
  --border: hsl(214 20% 90%);
  --radius: 14px;
  --shadow: 0 1px 2px hsl(222 47% 11% / 0.05), 0 2px 8px hsl(222 47% 11% / 0.04);

  min-height: 100dvh;
  overflow-x: hidden;
  background: var(--background);
  color: var(--foreground);
  font-family: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 15px;
  line-height: 1.4;
}
body:has(.client-shell) { margin: 0; background: hsl(210 20% 98%); }

.client-shell .field { display: flex; flex-direction: column; gap: 0.2rem; min-width: 10rem; }
.client-shell .field-label { font-size: 0.75rem; font-weight: 600; color: var(--muted-foreground); }
.client-shell select,
.client-shell input[type='search'] {
  height: 2.5rem;
  padding: 0 0.75rem;
  border: 1px solid var(--border);
  border-radius: calc(var(--radius) - 4px);
  background: #fff;
  color: var(--foreground);
  font: inherit;
  max-width: 100%;
  box-sizing: border-box;
}
.client-shell .button {
  height: 2.5rem;
  padding: 0 1rem;
  border: 1px solid var(--border);
  border-radius: calc(var(--radius) - 4px);
  background: #fff;
  color: var(--foreground);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.client-shell .button:hover:not(:disabled) { border-color: var(--primary); color: var(--primary-strong); }
.client-shell .button:disabled { opacity: 0.55; cursor: not-allowed; }
.client-shell .link {
  padding: 0;
  border: 0;
  background: none;
  color: var(--primary-strong);
  font: inherit;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}
.client-shell :focus-visible { outline: 3px solid hsl(142 72% 35% / 0.55); outline-offset: 2px; }
.client-shell .pasture-shape { cursor: default; }
.client-shell .pasture-shape:focus,
.client-shell .pasture-shape:focus-visible { outline: none; }

/* Marcador único de animal: ponto pequeno com contorno escuro; a cor é a idade da última leitura. */
.client-shell .animal-marker {
  box-sizing: border-box;
  border: 2px solid hsl(222 47% 11%);
  border-radius: 50%;
  cursor: pointer;
}
.client-shell .animal-marker--recent { background: #22c55e; }
.client-shell .animal-marker--one-day { background: #facc15; }
.client-shell .animal-marker--two-days { background: #ef4444; }
.client-shell .animal-marker--never { background: #94a3b8; }
.client-shell .animal-marker--selected {
  box-shadow: 0 0 0 3px #fff, 0 0 0 5px hsl(222 47% 11%);
  z-index: 1000 !important;
}

@media (prefers-reduced-motion: reduce) {
  .client-shell *,
  .client-shell *::before,
  .client-shell *::after {
    transition: none !important;
    animation: none !important;
    scroll-behavior: auto !important;
  }
}
</style>
